import './index.sass'
import './burger-styles.sass'
import { observer } from 'mobx-react'
import StoreContext from '../../store/RootStore'
import { useEffect, useRef } from 'react'
import LoginHandler from '../../functions/login'

function Header() {
  const { AccountStore } = StoreContext()
  const loginHandlerRef = useRef(null)

  // Crée une instance unique et stable de LoginHandler
  if (loginHandlerRef.current === null) {
    loginHandlerRef.current = new LoginHandler()
  }

  useEffect(() => {
    if (AccountStore.accountAddress) {
      loginHandlerRef.current.getUserBalancetkn()
      loginHandlerRef.current.getUserBalancewax()
    }

    if (AccountStore.avatarData.length === 0) {
      loginHandlerRef.current.getAvConfig()
    }
    // Dépendances explicitement mentionnées pour satisfaire eslint-plugin-react-hooks
  }, [AccountStore.accountAddress, AccountStore.avatarData.length])

  return (
    <div className="head">
      <div className="token">
        <div id="dov-x">
          <p>{parseFloat(AccountStore.getBlcData().dovx).toFixed(2)}</p>
        </div>
        <div id="dov-f">
          <p>{parseFloat(AccountStore.getBlcData().dovf).toFixed(2)}</p>
        </div>
        <div id="dov-h">
          <p>{parseFloat(AccountStore.getBlcData().dovh).toFixed(2)}</p>
        </div>
        <div id="dov-s">
          <p>{parseFloat(AccountStore.getBlcData().dovs).toFixed(2)}</p>
        </div>
        <div id="dov-r">
          <p>{parseFloat(AccountStore.getBlcData().dovr).toFixed(2)}</p>
        </div>
      </div>
    </div>
  )
}

export default observer(Header)
